const styleNumParse = (styleValue: string): number => parseInt(styleValue);

export default styleNumParse;
